import { CALL_API } from '../middleware/ApiMiddleware';

export const GROUP_FETCH_REQUEST = 'GROUP_FETCH_REQUEST';
export const GROUP_FETCH_SUCCESS = 'GROUP_FETCH_SUCCESS';
export const GROUP_FETCH_FAILURE = 'GROUP_FETCH_FAILURE';

export const GROUP_CREATE_REQUEST = 'GROUP_CREATE_REQUEST';
export const GROUP_CREATE_SUCCESS = 'GROUP_CREATE_SUCCESS';
export const GROUP_CREATE_FAILURE = 'GROUP_CREATE_FAILURE';

export const GROUP_UPDATE_REQUEST = 'GROUP_UPDATE_REQUEST';
export const GROUP_UPDATE_SUCCESS = 'GROUP_UPDATE_SUCCESS';
export const GROUP_UPDATE_FAILURE = 'GROUP_UPDATE_FAILURE';

export const GROUPS_FETCH_REQUEST = 'GROUPS_FETCH_REQUEST';
export const GROUPS_FETCH_SUCCESS = 'GROUPS_FETCH_SUCCESS';
export const GROUPS_FETCH_FAILURE = 'GROUPS_FETCH_FAILURE';

export const fetchGroup = (groupId: number) => ({
  [CALL_API]: {
    endpoint: `groups/${groupId}`,
    method: 'get',
    authenticated: true,
    types: [GROUP_FETCH_REQUEST, GROUP_FETCH_SUCCESS, GROUP_FETCH_FAILURE],
  },
});

export const createGroup = (group: IGroup) => ({
  [CALL_API]: {
    endpoint: 'groups',
    method: 'post',
    body: group,
    authenticated: true,
    types: [GROUP_CREATE_REQUEST, GROUP_CREATE_SUCCESS, GROUP_CREATE_FAILURE],
  },
});

export const updateGroup = (groupId: number, group: IGroup) => ({
  [CALL_API]: {
    endpoint: `groups/${groupId}`,
    method: 'put',
    body: group,
    authenticated: true,
    types: [GROUP_UPDATE_REQUEST, GROUP_UPDATE_SUCCESS, GROUP_UPDATE_FAILURE],
  },
});

export const fetchGroups = () => ({
  [CALL_API]: {
    endpoint: 'groups',
    method: 'get',
    authenticated: true,
    types: [GROUPS_FETCH_REQUEST, GROUPS_FETCH_SUCCESS, GROUPS_FETCH_FAILURE],
  },
});
